/* Emporium: line up product-tile prices.
   When a tile shows the name above the price (mobile), every name in the same visual row gets the
   height of the tallest name in that row. Rows where all names fit on one line are left alone. */
(function () {
  function stacked(info) {
    return getComputedStyle(info).flexDirection === 'column';
  }

  function alignGrid(grid) {
    var items = Array.prototype.filter.call(grid.children, function (li) { return li.offsetParent !== null; });
    var headings = [];
    items.forEach(function (li) {
      // Each tile has two .card__information blocks; use the one that's actually shown
      var info = Array.prototype.find.call(li.querySelectorAll('.card__information'), function (el) {
        return el.getClientRects().length > 0;
      });
      var h = info && info.querySelector('.card__heading');
      if (h) { h.style.minHeight = ''; headings.push({ h: h, info: info, top: Math.round(li.getBoundingClientRect().top + window.scrollY) }); }
    });
    if (!headings.length || !stacked(headings[0].info)) return;
    var rows = {};
    headings.forEach(function (x) { (rows[x.top] = rows[x.top] || []).push(x); });
    Object.keys(rows).forEach(function (k) {
      var row = rows[k];
      if (row.length < 2) return;
      var max = Math.max.apply(null, row.map(function (x) { return x.h.getBoundingClientRect().height; }));
      row.forEach(function (x) { x.h.style.minHeight = max + 'px'; });
    });
  }

  function run() {
    document.querySelectorAll('.product-grid, [id^="Slider-"]').forEach(alignGrid);
  }

  var t;
  function later() { clearTimeout(t); t = setTimeout(run, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  // Filtering / infinite scroll / section re-renders
  function watch() { new MutationObserver(later).observe(document.querySelector('main') || document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
